<template>
  <Main
    :tableData="tableData"
    :loading="loading"
    ref="main"
    @change="(e) => $emit('change', e)"
  >
    <template #header>
      <div class="side-frame-success">
        <span class="side-frame-text">车辆信息</span>
        <el-divider direction="vertical"></el-divider>
        <b-button
          class="mr-2"
          size="sm"
          variant="outline-success"
          @click="$refs.main.addRow()"
          ><i class="el-icon-plus" />添加
        </b-button>
        <b-button
          class="mr-2"
          size="sm"
          variant="outline-danger"
          @click="$refs.main.removeCheckboxRow()"
          ><i class="el-icon-delete" />删除
        </b-button>
      </div>
    </template>
  </Main>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: { waybillCode: { type: String, default: '' } },
  data() {
    return { tableData: [], loading: false }
  },
  watch: {
    waybillCode() {
      this.getData()
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.tableData = []
      if (!this.waybillCode) return
      this.loading = true
      const res = await this.$api
        .financeWaybillVehicleListApi(this.waybillCode)
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body.data
    },
    validate() {
      const tableData = this.getTableData()
      if (!tableData || !tableData.length) {
        this.$message.error('请添加车型信息')
        return false
      }
      return this.$refs.main.validate()
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
  },
}
</script>
